import { connectHook } from '../../connect-hook';
import { Number } from './number';
import { useNumber } from './number-hook';

export default connectHook(Number, useNumber);
